import { inject } from "@angular/core";
import type { AccountTableView } from "@bitwarden/web-vault/app/models/types/account.types";
import { CalculationTodayStoreService } from "@bitwarden/web-vault/app/services/store/calculation-today/calculation-today.store.service";
import { ImportStoreService } from "@bitwarden/web-vault/app/services/store/import/import.store.service";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";
import { SignalSubscriptionImpl } from "../../data-subscription";
import { getAccountTableViews } from "../account.table";
import { CalculationPastStoreService } from "@bitwarden/web-vault/app/services/store/calculation-past/calculation-past.store.service";
import { hashAccountTableViews } from "./account-view-table.utils";

export type TableSource = AccountTableView;
/**
 * This class only need to deal with angular dependency
 * and the core logic is in getAccountTableViews function which can be easily unit tested
 */
export class AccountViewTableSubscription extends SignalSubscriptionImpl<TableSource[]> {
  userStoreService: UserStoreService = inject(UserStoreService);
  importStoreService: ImportStoreService = inject(ImportStoreService);
  calculationStoreService: CalculationTodayStoreService = inject(CalculationTodayStoreService);
  calculationPastStoreService: CalculationPastStoreService = inject(CalculationPastStoreService);

  tableViews: AccountTableView[] = [];
  sourceDataHash: string = "";

  // TODO: this is a temporary solution to get the source data for the account table.
  // We need to find a better way to do this. The better way is to make sure that the stores are not updating data if the content is the same .
  get source() {
    const accountViews = this.calculationStoreService.filteredAccounts.collection();
    const balances = this.calculationStoreService.balanceByAccount.balances();
    const institutionViews = this.userStoreService.institutions.institutionViews();
    const preference = this.userStoreService.preferences.preferenceView();
    const syncStatusViews = this.importStoreService.syncStatus.syncStatusViews();

    if (
      accountViews == null ||
      accountViews.length === 0 ||
      institutionViews == null ||
      institutionViews.length === 0 ||
      preference == null ||
      balances == null ||
      balances.size === 0
    ) {
      return this.tableViews;
    }

    const nextViews = getAccountTableViews(
      accountViews,
      syncStatusViews ?? [],
      institutionViews,
      balances,
      preference,
    );
    const sortedViews = [...nextViews].sort((a, b) => (b.balance ?? 0) - (a.balance ?? 0));
    const nextHash = hashAccountTableViews(sortedViews);
    if (nextHash === this.sourceDataHash) {
      return this.tableViews;
    }
    this.tableViews = sortedViews;
    this.sourceDataHash = nextHash;
    return this.tableViews;
  }
}
